export const getEndpoint = (isProd) => {
    return isProd ? 'https://events.zahs.tv/ad_events' : 'https://events-staging.zahs.tv/ad_events';
};
